/**
 * 发布后自动检测新版本，避免用户手动清缓存。
 * 依赖构建产物根目录的 version.json（build 时生成）。
 */
const VERSION_KEY = 'app_build_version';
const CHECK_INTERVAL = 5 * 60 * 1000;

function fetchBuildVersion() {
  const url = `./version.json?_=${Date.now()}`;
  return fetch(url, { cache: 'no-store' })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
}

function applyNewVersion(version) {
  localStorage.setItem(VERSION_KEY, version);
  window.location.reload();
}

export function startVersionCheck() {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const check = () => {
    fetchBuildVersion().then((data) => {
      if (!data || !data.version) {
        return;
      }
      const cached = localStorage.getItem(VERSION_KEY);
      if (!cached) {
        localStorage.setItem(VERSION_KEY, data.version);
        return;
      }
      if (cached !== data.version) {
        applyNewVersion(data.version);
      }
    });
  };

  check();
  window.setInterval(check, CHECK_INTERVAL);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      check();
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/versionCheck.js